import React, { useEffect, useState, useCallback } from "react";
import api, { requestData } from "../services/requests";
import { useNavigate } from 'react-router-dom';
import { ChartColumn, KeyRound, CircleX} from "lucide-react"

const EditarDadosUsuario = () => {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  const url_atual = window.location.href;
  const id = url_atual.split('/')[4];

  const getUser = useCallback(async () => {
    const user = await requestData(`/user`);
    setEmail(user.email);
    setTelefone(user.telefone);
    setNome(user.name);
  }, [id])



  useEffect(() => {
    getUser()
  }, [getUser]);

  const salvarSenha = async () => {
    try {
      await api.patch(`/user/update/${id}`, {
        password: newPassword
      });
      alert('Senha atualizada com sucesso!');
    } catch (error) {
      console.log(error);
    }
  }


  const alterarSenha = () => {
    setOpenModal(true);
  }

  const backScreen = () => {
    navigate('/painel')
  }

  const fecharModal = () => {
    setOpenModal(false);
  }

  return (
    <section className="min-h-screen bg-gray-100">
      <div className="h-12 flex items-center text-sm ml-5 justify-between">
        <div className="flex items-center text-sm ml-2.5">
          <ChartColumn /> Painel » Perfil do Usuário
        </div>
        <button
          className="mr-5 bg-green-600 bg-opacity-70 text-white border-none p-2.5 rounded-md"
          onClick={() => backScreen()}
        > VOLTAR
        </button>
      </div>
      <div className="bg-white p-6 flex flex-col items-start">
        <h3 className="ml-2.5 text-blue-600 text-2xl font-light">Perfil do Usuário</h3>
        <div className="grid grid-cols-[400px_400px] gap-5">
          <label htmlFor="nome" className="m-2.5"> <span> Nome: </span>
            <input
              id="nome"
              type="text"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              className="mt-1 w-full h-10 border rounded p-2"
            />
          </label>
          <label htmlFor="email-input" className="m-2.5"> <span> Email: </span>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full h-10 border rounded p-2"
            />
          </label>
          <label htmlFor="telefone" className="m-2.5"> <span> Telefone: </span>
            <input
              id="telefone"
              type="text"
              value={telefone}
              onChange={(e) => setTelefone(e.target.value)}
              className="mt-1 w-full h-10 border rounded p-2"
            />
          </label>
        </div>
        <button className="flex relative text-white items-center justify-around rounded-md w-44 top-24 left-2.5 bg-yellow-500 border-none px-3 py-1.5" onClick={() => alterarSenha()}>
          <KeyRound />
          ALTERAR SENHA
        </button>
      </div>
      {openModal &&
        <>
          <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-90">
            <div className="bg-white opacity-100 flex flex-col w-[500px] h-[400px] justify-center">
              <CircleX onClick={() => fecharModal()} />
              <h3 className="text-xl self-start ml-12 text-blue-600 font-medium"> ALTERAR SENHA </h3>
              <label htmlFor="Password" className="flex flex-col max-w-md h-12 my-8 mx-12">
                <span>
                  Nova Senha: </span>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="h-12 border rounded p-2"
                />
              </label>
              <label htmlFor="newPassword" className="flex flex-col max-w-md h-12 my-8 mx-12"> <span> Confirmar a Nova Senha:</span>
                <input
                  id="newPassword"
                  type="password"

                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="h-12 border rounded p-2"
                />
              </label>
              <button
                disabled={newPassword === password && password !== "" ? false : true}
                className="self-center w-20 h-10 enabled:bg-green-600 enabled:text-white border-none disabled:opacity-50 rounded"
                onClick={() => salvarSenha()}>
                SALVAR </button>
            </div>
          </div>
        </>
      }
    </section>
  )
}

export default EditarDadosUsuario;
